<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
    <path
      d="M17 2.5H4C3.60218 2.5 3.22064 2.65804 2.93934 2.93934C2.65804 3.22064 2.5 3.60218 2.5 4V17C2.5 17.3978 2.65804 17.7794 2.93934 18.0607C3.22064 18.342 3.60218 18.5 4 18.5H17C17.3978 18.5 17.7794 18.342 18.0607 18.0607C18.342 17.7794 18.5 17.3978 18.5 17V4C18.5 3.60218 18.342 3.22064 18.0607 2.93934C17.7794 2.65804 17.3978 2.5 17 2.5Z"
      stroke-width="2"
      stroke-linejoin="round"
      :class="containerClass"
    />
    <path
      d="M22 6.50098V21C22 21.2652 21.8946 21.5195 21.7071 21.7071C21.5196 21.8946 21.2652 22 21 22H6.5015M6.5 10.243L9.5 13.0055L14.5 7.85948"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      :class="containerClass"
    />
  </svg>
</template>

<script>
export default {
  props: {
    className: {
      type:  [String, Array],
      default: "",
    },
    containerClass: {
      type: String,
      default: "",
    },
  },
};
</script>
